export const REPLACE_OFFICES = 'REPLACE_OFFICES';
export const ADD_OFFICE = 'ADD_OFFICE';
export const UPDATE_OFFICE = 'UPDATE_OFFICE';